import Components from "../components";

class Tags extends Components.Base {
  bind() {
    this.on("click", "a.edit-tags", (e) => this.toggleForm(e));
  }

  toggleForm(event) {
    event.preventDefault();
    this.$el
      .find(".c-tag-list,.edit,.edit-tags,.collapse")
      .toggleClass("collapse");
    this.$el.find("input[type=text]").focus();
  }
}

Components.collection.register({ selector: ".c-tags", klass: Tags });
